import { DataLayer } from "@grandvisionhq/analytics";
const eventName = "wishlist_click";
const wishlistButtonEventMapping = {
  pdp: {
    siteFeature: "product_detail_page",
    add: "wishlist_pdp_add_click",
    remove: "wishlist_pdp_remove_click"
  },
  plp: {
    siteFeature: "product_list_page",
    add: "wishlist_plp_add_click",
    remove: "wishlist_plp_remove_click"
  },
  crossSell: {
    siteFeature: "product_detail_page",
    add: "wishlist_pdp_cross_sell_add_click",
    remove: "wishlist_pdp_cross_sell_remove_click"
  },
  recentlyViewedProducts: {
    siteFeature: "recently_viewed_products",
    add: "wishlist_plp_recently_viewed_add_click",
    remove: "wishlist_plp_recently_viewed_remove_click"
  }
};
const getWishlistButtonEventInfo = (action, location) => {
  const interactionType = location ? wishlistButtonEventMapping[location]?.[action] : void 0;
  const siteFeature = location ? wishlistButtonEventMapping[location]?.siteFeature : void 0;
  return { interactionType, siteFeature };
};
const pushWishlistEvent = (event) => {
  const { siteFeature, interactionType, messageType, userLogged, item } = event;
  DataLayer.pushEvent({
    event: eventName,
    site_feature: siteFeature,
    interaction_type: interactionType,
    ...item ? { item: { item_sku: item.sku } } : null,
    ...messageType ? { message_type: messageType } : null,
    ...userLogged ? { user_logged: userLogged } : null
  });
};
export {
  eventName,
  getWishlistButtonEventInfo,
  pushWishlistEvent
};
//# sourceMappingURL=wishlist.js.map
